import { filterSelectInput } from "components/form/DefaultConsultView/components/FilterInputs";
import Entity from "entity";

export default class Insumo extends Entity {
    static get collectionUID() {
        return "ValueCustomForm/COjVxGeK1qygjFXmh4ek/Values";
    }

    static async onQuery(collection) {
        return collection.where("status", "==", "ATIVO").orderBy("nomeInsumo");
    }

    async initialize() {
        this.data.status = "ATIVO"
    }

    static get labelField() {
        return "nomeInsumo";
    }

    static get searchColumns() {
        return [
            { field: "sequencialIndex", headerName: "Código", flex: 0.4, filter: true },
            {
                field: "status", headerName: "Status", flex: 1, filter: filterSelectInput("status", "Status", ["ATIVO", "INATIVO"])
            },
            { field: "nomeInsumo", headerName: "(Inseticida/Formulado/Variedade)", flex: 1, filter: true },
            { field: "tipo", headerName: "Tipo", flex: 0.8 },
        ];
    }
}
